export default __webpack_public_path__ + "static/media/flameIcon.f2edf4b2.svg";